<template>
    <div>
        <iframe src="https://e.modocker.com/link/?id=K2o6YQm3c9l8f7QBnntuE2O6A12359s3&preload=1&logo=0&toolbar=0&rotation=0" frameborder="0"></iframe>
    </div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>
    iframe{
        width: 100vw;
        height: 100vh;
    }

</style>


// WEBPACK FOOTER //
// src/components/test/index.vue